import Spinner from '@carvana/ds-spinner';
import React from 'react';
import { EventedModal, ModalNames } from '|/app/modals';
import styles from './plaid-modal.module.css';
import { usePlaid } from './use-plaid';

interface PlaidModalProps {
  isOpen: boolean;
  onClose: () => void;
  paymentAmount: number;
  onSuccess: () => void;
  onExit: () => void;
  onError: () => void;
}

const PlaidContent = ({
  paymentAmount,
  onSuccess,
  onExit,
  onError
}: Pick<PlaidModalProps, 'paymentAmount' | 'onSuccess' | 'onExit' | 'onError'>) => {
  const { plaidStyleOverride } = usePlaid({
    paymentAmount,
    onSuccess,
    onExit,
    onError
  });

  return (
    <>
      <div className={styles.container}>
        <Spinner size={57} />
      </div>

      {plaidStyleOverride}
    </>
  );
};

export const PlaidModal = ({
  isOpen,
  onClose,
  paymentAmount,
  onSuccess,
  onExit,
  onError
}: PlaidModalProps) => (
  <EventedModal
    isOpen={isOpen}
    analyticsId={ModalNames.PlaidModalCompletePurchase}
    onClose={onClose}
    className={styles.modal}
    closeIcon={false}
    divLine={false}
    desktopWidth="360px"
    mobileStyle="full"
    disableOutsideClose
    disableEscapeClose
    contentPadding={false}
    aria-label="Connect your bank account"
  >
    {isOpen && (
      <PlaidContent
        paymentAmount={paymentAmount}
        onSuccess={onSuccess}
        onExit={onExit}
        onError={onError}
      />
    )}
  </EventedModal>
);
